import React from 'react';
import Badge from './Badge';
import { formatDateTimeInTzWithLocale } from '@utils/dateWithTz';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { FiEdit } from 'react-icons/fi';

interface ComponentProps {
  createdAt: string;
  createdBy: string;
  createdEmail: string;
  timezoneId: string;
  dataTestId?: string;
}

const CreatedBadge: React.FC<ComponentProps> = ({ createdAt, createdBy, createdEmail, timezoneId, dataTestId }) => {
  const { tr } = useTranslationLgs();
  return (
    <>
      <a href={`mailto:${createdEmail}`}>
        <Badge
          text={tr('CreatedBadge.createdWithTz', '{{fullName}} ({{-dateWithTimeDash}})', {
            fullName: createdBy,
            dateWithTimeDash: formatDateTimeInTzWithLocale(createdAt, timezoneId),
          })}
          icon={<FiEdit />}
          dataTestId={dataTestId}
        />
      </a>
    </>
  );
};

export default CreatedBadge;
